import { Directive, TemplateRef, input } from '@angular/core';
import { TreeNode } from '@openng/optimus-ui/api';
import { IOption } from '../forms.utils';

export const SelectFormControlDirectiveInputs = [
  'optionTemplate',
  'emptyMessage',
  'searchable',
  'options',
  'checkboxOptions',
  'selectOptions',
  'maxSelectedLabels',
];

@Directive({
  selector: '[uiSelectFormControl]',
  standalone: true,
})
export class SelectFormControlDirective {
  readonly optionTemplate = input<TemplateRef<unknown> | null>(null);

  readonly emptyMessage = input<string | null>('Žádné výsledky');

  readonly searchable = input(false);

  readonly options = input<IOption[] | unknown[]>([]);

  readonly checkboxOptions = input<IOption[]>([]);

  readonly maxSelectedLabels = input(2);

  readonly selectOptions = input<TreeNode[]>();
}
